import React from 'react'
import {LogoSpinner} from 'shared'
import classNames from 'classnames'

const loadingStyle = {
  color: 'transparent',
  textShadow: 'none',
  lineHeight: 0
}

export const Button = (props) => {
  const {loading, className, children, smallSpinner, ...buttonProps} = props

  return <button
    className={classNames('btn btn-primary', className)}
    disabled={loading} // Can be overriden with buttonProps
    style={loading ? loadingStyle : {}}
    type='submit'
    {...buttonProps}
  >
    {loading && <LogoSpinner smallSpinner />}
    {children}
  </button>
}
